import { render, staticRenderFns } from "./FormattedAddress.vue?vue&type=template&id=5642642e&scoped=true&"
import script from "./FormattedAddress.vue?vue&type=script&lang=js&"
export * from "./FormattedAddress.vue?vue&type=script&lang=js&"
import style0 from "./FormattedAddress.vue?vue&type=style&index=0&id=5642642e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642642e",
  null
  
)

export default component.exports